import { BrowserRouter, Route, Routes, useLocation, useNavigate } from "react-router";
import { MainLayout } from "../layout";
import { HomePage } from "../pages/home";
import SmiNewsPage from "../pages/news/Smi/page";
import { useEffect } from "react";
import { useConfiguration } from "../hooks/useConfiguration";
import { Configuration, SiteType } from "../types/common";
import SocialFeedPage from "../pages/news/SocialFeed/page";
import { CalendarPageApp, PlayersStatsPageApp, TournamentTablePageApp } from "./stats";
import MatchdayPage from "../pages/my/Matchday/page";
import Contests from "../pages/my/Contests/page";
import { MyTDesignPage } from "../pages/my/TDesign/page";
import MyAppPage from "../pages/my/MyApp/page";
import { PlayerProfilePageApp, TeamPlayersPageApp } from "./team";
import CoachesPage from "../pages/club/coaches/page";
import { Club100Page } from "../pages/club/club100/page";
import ManagementPage from "../pages/club/management/page";
import VacanciesListPage from "../pages/jobs/page";
import { StadiumPage } from "../pages/club/stadium";
import { PartnersPage } from "../pages/club/partners/page";
import { AboutClubPageApp, VacancyPageApp } from "./club";
import { ExPlayersPage } from "../pages/club/ex-players/page";
import { PlayerProfilePage } from "../pages/player/page";
import NewsPage from "../pages/news/List/page";
import { ContactsPage } from "../pages/club/contacts/page";
import NewsItemPage from "../pages/news/Item/page";
import FanMVPListPage from "../pages/fan-mvp/page";
import { MatchCenterPage } from "../pages/match/page";
import { VacancyPage } from "../pages/jobs/vacancy/page";
import LauncherPage from "../pages/launcher/page";
import ScrollToTopRouter from "../components/ScrollToTopRouter";
import AdministrativePage from "../pages/club/administrative/page";
import { AcademyEducationPage } from "../pages/club/academy-education";
import AcademyAboutClubPage from "../pages/club/academy";
import RegPage from "../pages/reg";
import { SummaryTablesPage } from "../pages/stats/summary-tables/page";

export const RootApp = () => {
    const config: Configuration = useConfiguration(true);
    config.standalone = true;

    return (
        <BrowserRouter>
            <ScrollToTopRouter />
            <MainLayout>
                {config.site === SiteType.LEGACY_RODINA && <AppRoutes />}
                {config.site === SiteType.LEGACY_ACADEMY && <AcademyRoutes />}
            </MainLayout>
        </BrowserRouter>
    );
}

const RefreshRoute = () => {
    useEffect(() => {
        const searchParams = new URLSearchParams(globalThis.location.search);
        if (searchParams.has("rr")) {
            return;
        }

        searchParams.append("rr", "1");

        globalThis.location.assign(window.location.pathname + "?" + searchParams.toString());
    }, []);

    return null;
}

const RedirectRoute = ({ url = '/' }) => {
    const navigate = useNavigate();
    useEffect(() => {
        navigate('/')
    }, []);

    return null;
}

export const AppRoutes = () => {
    return (
        <Routes>
            {/*<Route index element={<HomePage />} />*/}
            <Route path="/rodina" element={<HomePage />} />
            {/*<Route path="/" element={<LauncherPage />} />*/}
            <Route path="/timeline" element={<SocialFeedPage />} />
            <Route path="/news/digest" element={<SmiNewsPage />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/news/:newsUrl" element={<NewsItemPage />} />

            <Route path="/games" element={<CalendarPageApp />} />
            <Route path="/season/calendar" element={<CalendarPageApp />} />
            <Route path="/matches/matchcenter/:matchId" element={<MatchCenterPage />} />
            <Route path="/games/tables" element={<TournamentTablePageApp />} />
            <Route path="/season/table" element={<TournamentTablePageApp />} />
            <Route path="/tables" element={<TournamentTablePageApp />} />
            <Route path="/games/stat/" element={<PlayersStatsPageApp />} />

            <Route path="/matchday" element={<MatchdayPage />} />
            <Route path="/goroda" element={<Contests />} />
            <Route path="/design" element={<MyTDesignPage />} />
            <Route path="/fan-app/" element={<MyAppPage />} />
            <Route path="/fan-mvp/" element={<FanMVPListPage />} />

            <Route path="/team" element={<TeamPlayersPageApp />} />
            <Route path="/team/ex-rodina" element={<ExPlayersPage />} />
            <Route path="/team/players/:playerId" element={<PlayerProfilePageApp />} />
            <Route path="/club/trainers" element={<CoachesPage />} />
            <Route path="/team/club-100" element={<Club100Page />} />

            <Route path="/club" element={<AboutClubPageApp />} />
            <Route path="/club/management" element={<ManagementPage />} />
            <Route path="/jobs" element={<VacanciesListPage />} />
            <Route path="/jobs/:vacancyUuid" element={<VacancyPageApp />} />
            <Route path="/stadium" element={<StadiumPage />} />
            <Route path="/partners" element={<PartnersPage />} />
            <Route path="/club/contacts" element={<ContactsPage />} />

            <Route path="/2/" element={<HomePage />} />
            <Route path="/2/news" element={<NewsPage />} />
            <Route path="/2/news/:newsUrl/" element={<NewsItemPage />} />
            <Route path="/2/games" element={<CalendarPageApp />} />
            <Route path="/2/games/stat/" element={<PlayersStatsPageApp />} />
            <Route path="/2/matches/matchcenter/:matchId" element={<MatchCenterPage />} />
            <Route path="/2/games/tables" element={<TournamentTablePageApp />} />
            <Route path="/2/season/table" element={<TournamentTablePageApp />} />
            <Route path="/2/tables" element={<TournamentTablePageApp />} />
            <Route path="/2/team" element={<TeamPlayersPageApp />} />
            <Route path="/2/team/players/:playerId" element={<PlayerProfilePageApp />} />
            <Route path="/2/club" element={<AboutClubPageApp />} />
            <Route path="/2/club/trainers" element={<CoachesPage />} />
            <Route path="/2/club/management" element={<ManagementPage />} />
            <Route path="/2/jobs" element={<VacanciesListPage />} />
            <Route path="/2/jobs/:vacancyUuid" element={<VacancyPageApp />} />
            <Route path="/2/stadium" element={<StadiumPage />} />
            <Route path="/2/partners" element={<PartnersPage />} />
            <Route path="/2/club/contacts" element={<ContactsPage />} />

            <Route path="/m/" element={<HomePage />} />
            <Route path="/m/news" element={<NewsPage />} />
            <Route path="/m/news/:newsUrl" element={<NewsItemPage />} />
            <Route path="/m/games" element={<CalendarPageApp />} />
            <Route path="/m/games/stat/" element={<PlayersStatsPageApp />} />
            <Route path="/m/matches/matchcenter/:matchId" element={<MatchCenterPage />} />
            <Route path="/m/games/tables" element={<TournamentTablePageApp />} />
            <Route path="/m/season/table" element={<TournamentTablePageApp />} />
            <Route path="/m/tables" element={<TournamentTablePageApp />} />
            <Route path="/m/team" element={<TeamPlayersPageApp />} />
            <Route path="/m/team/players/:playerId" element={<PlayerProfilePageApp />} />
            <Route path="/m/club" element={<AboutClubPageApp />} />
            <Route path="/m/club/trainers" element={<CoachesPage />} />
            <Route path="/m/club/management" element={<ManagementPage />} />
            <Route path="/m/jobs" element={<VacanciesListPage />} />
            <Route path="/m/jobs/:vacancyUuid" element={<VacancyPageApp />} />
            <Route path="/m/stadium" element={<StadiumPage />} />
            <Route path="/m/partners" element={<PartnersPage />} />
            <Route path="/m/club/contacts" element={<ContactsPage />} />

            <Route path="/3/" element={<HomePage />} />
            <Route path="/3/news" element={<NewsPage />} />
            <Route path="/3/news/:newsUrl" element={<NewsItemPage />} />
            <Route path="/3/games" element={<CalendarPageApp />} />
            <Route path="/3/games/stat/" element={<PlayersStatsPageApp />} />
            <Route path="/3/matches/matchcenter/:matchId" element={<MatchCenterPage />} />
            <Route path="/3/games/tables" element={<TournamentTablePageApp />} />
            <Route path="/3/season/table" element={<TournamentTablePageApp />} />
            <Route path="/3/tables" element={<TournamentTablePageApp />} />
            <Route path="/3/team" element={<TeamPlayersPageApp />} />
            <Route path="/3/team/players/:playerId" element={<PlayerProfilePageApp />} />
            <Route path="/3/club" element={<AboutClubPageApp />} />
            <Route path="/3/club/trainers" element={<CoachesPage />} />
            <Route path="/3/club/management" element={<ManagementPage />} />
            <Route path="/3/jobs" element={<VacanciesListPage />} />
            <Route path="/3/jobs/:vacancyUuid" element={<VacancyPageApp />} />
            <Route path="/3/stadium" element={<StadiumPage />} />
            <Route path="/3/partners" element={<PartnersPage />} />
            <Route path="/3/club/contacts" element={<ContactsPage />} />

            <Route path="/y/" element={<HomePage />} />
            <Route path="/y/news" element={<NewsPage />} />
            <Route path="/y/news/:newsUrl" element={<NewsItemPage />} />
            <Route path="/y/games" element={<CalendarPageApp />} />
            <Route path="/y/games/stat/" element={<PlayersStatsPageApp />} />
            <Route path="/y/matches/matchcenter/:matchId" element={<MatchCenterPage />} />
            <Route path="/y/games/tables" element={<TournamentTablePageApp />} />
            <Route path="/y/season/table" element={<TournamentTablePageApp />} />
            <Route path="/y/tables" element={<TournamentTablePageApp />} />
            <Route path="/y/team" element={<TeamPlayersPageApp />} />
            <Route path="/y/team/players/:playerId" element={<PlayerProfilePageApp />} />
            <Route path="/y/academy/trainers" element={<CoachesPage />} />
            <Route path="/y/academy/management" element={<ManagementPage />} />
            <Route path="/y/jobs" element={<VacanciesListPage />} />
            <Route path="/y/jobs/:vacancyUuid" element={<VacancyPageApp />} />
            <Route path="/y/stadium" element={<StadiumPage />} />
            <Route path="/y/partners" element={<PartnersPage />} />
            <Route path="/y/academy/contacts" element={<ContactsPage />} />

            <Route path="/youth/" element={<HomePage />} />
            <Route path="/youth/news" element={<NewsPage />} />
            <Route path="/youth/news/:newsUrl" element={<NewsItemPage />} />
            <Route path="/youth/games" element={<CalendarPageApp />} />
            <Route path="/youth/games/stat/" element={<PlayersStatsPageApp />} />
            <Route path="/youth/matches/matchcenter/:matchId" element={<MatchCenterPage />} />
            <Route path="/youth/games/tables" element={<TournamentTablePageApp />} />
            <Route path="/youth/season/table" element={<TournamentTablePageApp />} />
            <Route path="/youth/tables" element={<TournamentTablePageApp />} />
            <Route path="/youth/team" element={<TeamPlayersPageApp />} />
            <Route path="/youth/team/players/:playerId" element={<PlayerProfilePageApp />} />
            <Route path="/youth/academy/team/" element={<TeamPlayersPageApp />} />
            <Route path="/youth/academy/trainers" element={<CoachesPage />} />
            <Route path="/youth/academy/personal" element={<AdministrativePage />} />
            <Route path="/youth/academy/management" element={<ManagementPage />} />
            <Route path="/youth/jobs" element={<VacanciesListPage />} />
            <Route path="/youth/jobs/:vacancyUuid" element={<VacancyPageApp />} />
            <Route path="/youth/stadium" element={<StadiumPage />} />
            <Route path="/youth/partners" element={<PartnersPage />} />
            <Route path="/youth/academy/contacts" element={<ContactsPage />} />

            <Route path="/academy" element={<AcademyAboutClubPage />} />
            <Route path="/reg" element={<RegPage />} />
            <Route path="/academy/team/:teamYear?" element={<TeamPlayersPageApp />} />
            <Route path="/academy/education" element={<AcademyEducationPage />} />
            <Route path="/academy/trainers" element={<CoachesPage />} />
            <Route path="/academy/personal" element={<AdministrativePage />} />
            <Route path="/academy/management" element={<ManagementPage />} />
            <Route path="/academy/contacts" element={<ContactsPage />} />

            <Route path="*/search" element={<RefreshRoute />} />

            <Route path="*" element={<RedirectRoute url="/" />} />
        </Routes>
    )
}

const AcademyRoutes = () => {
    return (
        <Routes>
            <Route index element={<HomePage />} />
            <Route path="/" element={<LauncherPage />} />
            <Route path="/youth/" element={<HomePage />} />
            <Route path="/youth/news" element={<NewsPage />} />
            <Route path="/youth/news/:newsUrl" element={<NewsItemPage />} />
            <Route path="/youth/games" element={<CalendarPageApp />} />
            <Route path="/youth/games/stat/" element={<PlayersStatsPageApp />} />
            <Route path="/youth/matches/matchcenter/:matchId" element={<MatchCenterPage />} />
            <Route path="/youth/games/tables" element={<TournamentTablePageApp />} />
            <Route path="/youth/season/table" element={<TournamentTablePageApp />} />
            <Route path="/youth/tables" element={<TournamentTablePageApp />} />
            <Route path="/youth/team" element={<TeamPlayersPageApp />} />
            <Route path="/youth/team/players/:playerId" element={<PlayerProfilePageApp />} />
            <Route path="/youth/academy/team/" element={<TeamPlayersPageApp />} />
            <Route path="/youth/academy/trainers" element={<CoachesPage />} />
            <Route path="/youth/academy/personal" element={<AdministrativePage />} />
            <Route path="/youth/academy/management" element={<ManagementPage />} />
            <Route path="/youth/jobs" element={<VacanciesListPage />} />
            <Route path="/youth/jobs/:vacancyUuid" element={<VacancyPageApp />} />
            <Route path="/youth/stadium" element={<StadiumPage />} />
            <Route path="/youth/partners" element={<PartnersPage />} />
            <Route path="/youth/academy/contacts" element={<ContactsPage />} />

            <Route path="/academy" element={<AcademyAboutClubPage />} />
            <Route path="/academy/team/:teamYear?" element={<TeamPlayersPageApp />} />
            <Route path="/academy/education" element={<AcademyEducationPage />} />
            <Route path="/academy/trainers" element={<CoachesPage />} />
            <Route path="/academy/personal" element={<AdministrativePage />} />
            <Route path="/academy/management" element={<ManagementPage />} />
            <Route path="/academy/contacts" element={<ContactsPage />} />
            <Route path="/stadium" element={<StadiumPage />} />
            <Route path="/partners" element={<PartnersPage />} />
            <Route path="/jobs" element={<VacanciesListPage />} />
            <Route path="/jobs/:vacancyUuid" element={<VacancyPageApp />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/news/:newsUrl" element={<NewsItemPage />} />
            <Route path="/games" element={<CalendarPageApp />} />
            <Route path="/season/calendar" element={<CalendarPageApp />} />
            <Route path="/matches/matchcenter/:matchId" element={<MatchCenterPage />} />
            <Route path="/games/tables" element={<TournamentTablePageApp />} />
            <Route path="/season/table" element={<TournamentTablePageApp />} />
            <Route path="/tables" element={<SummaryTablesPage />} />
            <Route path="/games/stat/" element={<PlayersStatsPageApp />} />
            <Route path="/team" element={<TeamPlayersPageApp />} />
            <Route path="/team/players/:playerId" element={<PlayerProfilePageApp />} />
            <Route path="/reg" element={<RegPage />} />

            <Route path="*/search" element={<RefreshRoute />} />

            <Route path="*" element={<RedirectRoute url="/" />} />
        </Routes>
    );
}